"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var collapsible_1 = require("./collapsible");
Object.defineProperty(exports, "initCollapsibles", { enumerable: true, get: function () { return collapsible_1.default; } });
var tabs_1 = require("./tabs");
Object.defineProperty(exports, "initTabs", { enumerable: true, get: function () { return tabs_1.default; } });
var links_1 = require("./links");
Object.defineProperty(exports, "initLinks", { enumerable: true, get: function () { return links_1.default; } });
//# sourceMappingURL=index.js.map